import { useDispatch } from "react-redux";

import {
  getOptionsData,
  getFiltersFieldData,
  getListData,
  getColumnsData,
  setDownloadData,
  clearListState,
  clearDownload,
  reset,
} from "./index";

export const useSubaffiliateReportV2 = () => {
  const dispatch = useDispatch();

  const getOptions = () => dispatch(getOptionsData());
  const getFiltersField = (data: any) => dispatch(getFiltersFieldData(data));
  const getList = (data: any) => dispatch(getListData(data));
  const getColumns = () => dispatch(getColumnsData());
  const setDownload = (data: any) => dispatch(setDownloadData(data));
  const clearList = () => dispatch(clearListState());
  const clearDownloadState = () => dispatch(clearDownload());
  const resetState = () => dispatch(reset());

  return {
    getOptions,
    getFiltersField,
    getList,
    getColumns,
    setDownload,
    clearList,
    clearDownloadState,
    resetState,
  }
}
